const VIEWS_MAP: Record<string, number> = {
  0: 382,
  1: 421,
  2: 467,
  3: 398,
  4: 513,
  5: 445,
  6: 489,
  7: 356,
  8: 534,
  9: 472,
  a: 408,
  b: 527,
  c: 365,
  d: 491,
  e: 438,
  f: 503,
};

const SHORTLISTS_MAP: Record<string, number> = {
  0: 4,
  1: 7,
  2: 2,
  3: 9,
  4: 5,
  5: 1,
  6: 8,
  7: 3,
  8: 10,
  9: 6,
  a: 7,
  b: 2,
  c: 9,
  d: 4,
  e: 6,
  f: 3,
};

const getHexChar = (str: string): string => {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = Math.imul(hash, 31) + str.charCodeAt(i);
  }

  return (Math.abs(hash) % 16).toString(16);
};

const FALLBACK_KEY = '5';

export const getAuctionStats = (offerExpiry?: string) => {
  if (!offerExpiry) {
    return { shortlists: SHORTLISTS_MAP[FALLBACK_KEY], views: VIEWS_MAP[FALLBACK_KEY] };
  }

  const key = getHexChar(offerExpiry);

  return {
    shortlists: SHORTLISTS_MAP[key],
    views: VIEWS_MAP[key],
  };
};
